
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0g4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0g4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbGFnaSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbGFnaSJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbW9yZSJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0g4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0g4LmA4Lie4Li04LmI4Lih4LmA4LiV4Li04LihIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbGFnaSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6IntyZW1haW5pbmdDb3VudH0gbGFnaSJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6Ilt7cmVtYWluaW5nQ291bnR9IG3MgsO2w7bFmeG6veG6vV0ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJyZW1haW5pbmdDb3VudCsgbW9yZSI6Ilt7cmVtYWluaW5nQ291bnR9IG3MgsO2w7bFmeG6veG6vV0ifQ==!"
        )
      )
      });
  
      export { translations as default };
    